'use client';

import PropTypes from 'prop-types';
import { pad, timeLeft, useNow } from '@/lib/homepage/useNow';

/** Split-flap style countdown, for the hero and the draw board. */
export default function FlipClock({ endDate, size = 'm', className = '' }) {
  const now = useNow();
  const t = timeLeft(endDate, now);

  const cells = [
    ...(t && t.days > 0 ? [['Days', t.days]] : []),
    ['Hrs', t ? t.hours : null],
    ['Min', t ? t.minutes : null],
    ['Sec', t ? t.seconds : null],
  ];

  return (
    <div role="timer" aria-live="off" className={`flex gap-1.5 ${className}`}>
      {cells.map(([name, value]) => (
        <div key={name} className="text-center">
          <span className={`flip ${size === 'l' ? 'flip-l' : ''}`}>{value == null ? '--' : pad(value)}</span>
          <span className="mt-1.5 block text-[0.7rem] font-semibold uppercase tracking-[0.1em] text-muted-foreground">
            {name}
          </span>
        </div>
      ))}
    </div>
  );
}

FlipClock.propTypes = {
  endDate: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['m', 'l']),
  className: PropTypes.string,
};
